/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
  <div class="company">
    <div class="desc-wrap">
      <p class="p1">
        <span class="title">
          {{$t("common.companyName")}}
        </span>
      </p>
      <p class="p2">
        {{$t("about.content1")}}
        <br />
        <br />
        {{$t("about.content2")}}
        <br />
        <br />
        {{$t("about.content3")}}
      </p>
      <!--            <img src="../../assets/h2-img-9.jpg">-->
    </div>
    <CourseChunk></CourseChunk>
    <div style="width: 100%;background-color: #fafafa">
      <HonourChunk></HonourChunk>
    </div>
    <TeamChunk></TeamChunk>
    <!-- 企业文化 -->
    <div style="width: 100%;background-color: #fafafa">
      <CultureChunk></CultureChunk>
    </div>
  </div>
</template>

<script>
import CourseChunk from "./company-chunks/course-chunk"
import TeamChunk from "./company-chunks/team-chunk"
import HonourChunk from "./company-chunks/honour-chunk.vue"
import CultureChunk from "./company-chunks/culture-chunk.vue"

export default {
  name: "company",
  components: { CourseChunk, TeamChunk, HonourChunk, CultureChunk },

}
</script>

<style lang="less" scoped>
    @import "../../style/constant.less";

    .company {
        width: 100%;
        margin: 0 auto;
    }

    .desc-wrap {
        display: flex;
        color: @content-color;
        width: @page-width;
        margin: 160px auto 120px;
        padding: 60px;
        background: #FBFBFB url("../../assets/bglogo.png") no-repeat center;

        .title {
            font-weight: 500;
            font-size: 32px;
            line-height: 1.2em;
            color: @title-color;
        }
        .p1 {
            position: relative;
            width: 30%;
            &::after {
                position: absolute;
                content: " ";
                background-color: #D9D9D9;
                width: 1px;
                top: 0px;
                left:289px;
                bottom: 0px;
            }
        }
        .p2 {
            width: 70%;
            letter-spacing: 1px;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .desc-wrap {
            width: 90%;
            padding: 60px 15px 15px 15px;
            flex-direction: column;
            margin: 0 auto;
            .title {
                font-size: 24px;
            }
            img{
                height: 50vh;
            }
            .p1 {
                margin-bottom: 20px;
                &::after {
                    content: " ";
                    width:0px;
                    min-height: 0px;
                }
            }
            .p1, .p2 {
                width: 100%;
            }

        }
    }

</style>
